import React, { useContext } from "react";
import TradathonContext from "../../context/tradathon/TradathonContext";
import ParameterContext from "../../context/parameter/parameterContext";

const FakeShowCoins = ({ history }) => {
  const { activeRoom } = useContext(TradathonContext);
  const { vtButton } = useContext(ParameterContext);

  const handleClick = (id) => {
    history?.push(`/cryptos/${id}`);
  };

  return (
    <div style={{ overflow: "auto" }}>
      {activeRoom && activeRoom.room.rstatus === 0 ? (
        <table
          className="Home__MainTable"
          style={{ marginTop: "10px", minHeight: "400px" }}
        >
          <thead>
            <tr>
              <th></th>

              <th style={{ textAlign: "left" }}>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Coin</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Quantity</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Total Investment</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Average Price</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Current Price</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>P & L</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div>
                    <p>% Ch</p>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {[...Array(9).keys()].map((c) => (
              <>
                <tr key={c.rank} className="Home__MainTable__link">
                  <td style={{ textAlign: "left" }}>
                    <div className="skeleton text" style={{ width: "40px" }} />
                  </td>

                  <td style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-td">
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-td">
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>
                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div>
                        <div
                          className="skeleton text"
                          style={{ width: "120px" }}
                        />
                      </div>
                    </div>
                  </td>

                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      {" "}
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>
                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      {" "}
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      ) : vtButton === "position" ? (
        <table className="Home__MainTable" style={{ marginTop: "10px" }}>
          <thead>
            <tr>
              <th></th>

              <th style={{ textAlign: "left" }}>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Coin</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Quantity</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Total Investment</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Average Price</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Current Price</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>P & L</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div>
                    <p>% Ch</p>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {[...Array(7).keys()].map((c, index) => (
              <>
                <tr key={index} className="Home__MainTable__link">
                  <td style={{ textAlign: "left" }}>
                    <div className="skeleton text" style={{ width: "30px" }} />
                  </td>

                  <td style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-td">
                      <div
                        className="skeleton text"
                        style={{ width: "200px" }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-td">
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>
                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>

                  {/* <NumberFormat
                            value={c.price}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={`${currencySymbol} `}
                            /> */}

                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>
                  <td>
                    <div
                      className="Home__MainTable-td"
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(c.id)}
                    >
                      <div
                        className="skeleton text"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      ) : vtButton === "history" ? (
        <table className="Home__MainTable" style={{ marginTop: "10px" }}>
          <thead>
            <tr>
              <th></th>
              <th style={{ textAlign: "left" }}>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Type</div>
                  </div>
                </div>
              </th>
              <th style={{ textAlign: "left" }}>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Coin</div>
                  </div>
                </div>
              </th>

              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div onClick={() => {}} style={{ cursor: "pointer" }}>
                      Quantity
                    </div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Price</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Total Val</div>
                  </div>
                </div>
              </th>

              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Time</div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {[...Array(7).keys()].map((c, index) => (
              <>
                <tr key={index} className="Home__MainTable__link">
                  {[...Array(7).keys()].map((c) => (
                    <td style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-td">
                        <div
                          className="skeleton text"
                          style={{ width: "120px" }}
                        />
                      </div>
                    </td>
                  ))}
                </tr>
              </>
            ))}
          </tbody>
        </table>
      ) : (
        <table className="Home__MainTable" style={{ marginTop: "10px" }}>
          <thead>
            <tr>
              <th></th>
              <th style={{ textAlign: "left" }}>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Type</div>
                  </div>
                </div>
              </th>
              <th style={{ textAlign: "left" }}>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Coin</div>
                  </div>
                </div>
              </th>

              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Quantity</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Total Investment</div>
                  </div>
                </div>
              </th>
              <th>
                <div className="Home__MainTable-th">
                  <div
                    style={{
                      color: "white",
                    }}
                    className="Home__MainTable__pct"
                  >
                    &nbsp;
                    <div style={{ cursor: "pointer" }}>Trigger Price</div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {[...Array(10).keys()].map((c, index) => (
              <>
                <tr key={index} className="Home__MainTable__link">
                  {[...Array(6).keys()].map((c) => (
                    <td style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-td">
                        <div
                          className="skeleton text"
                          style={{ width: "120px" }}
                        />
                      </div>
                    </td>
                  ))}
                </tr>
              </>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FakeShowCoins;
